import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Amount } from 'src/app/model/home/year';
import { Welcome } from '../../../model/home/welcome';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class HomeService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the 'Home' json data
   * @returns an Observable
   */
  public getHomeData(): Observable<Welcome> {
    return this.authGetObs<Welcome>(APIUrls.getHomeUrl());
  }

  /**
   * Get the 'Home' sum of sales by year json data for ALL currencies
   * @returns an Observable
   */
  public getTotalSalesTwoYears(): Observable<Amount[]> {
    return this.authGetObs<Amount[]>(APIUrls.getSalesTwoYearsUrl());
  }
}
